import { urls } from "config/urls";
import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (user) => {
  if (socket && socket.connected) {
    console.log("User already connected:", socket.id);
    return socket;
  }

  socket = io(urls.SOCKET_URL, {
    transports: ["websocket"],
    autoConnect: true,
  });

  socket.on("connect", () => {
    socket.emit("user_connected", {
      userId: user?.id,
      email: user?.email,
      deviceId: user?.deviceId,
    });
  });

  socket.on("user_connected", (data) => {
    if (data?.is_success) {
      console.log("User connected successfully. Listening for new emails...");
    } else {
      console.warn("User connection failed:", data);
    }
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket disconnected:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (!socket) return;

  socket.disconnect();
  socket = null;
};

export const getSocket = () => socket;
